import React from "react";
import { View } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function Work(props) {
  const color = props.color || "#FFFFFF";
  const width = props.width || 32;
  const height = props.height || 32;

  return (
    <View {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M20.9784 8.90961H11.0127C10.1796 8.90961 9.50415 9.58503 9.50415 10.4182V16.4171C9.50415 17.2503 10.1796 17.9257 11.0127 17.9257H20.9784C21.8115 17.9257 22.487 17.2503 22.487 16.4171V10.4182C22.487 9.58503 21.8115 8.90961 20.9784 8.90961Z"
          stroke={color}
          strokeWidth="2.04104"
          strokeMiterlimit="10"
        />
        <Path
          d="M22.2297 20.0466C22.4249 20.2684 22.6823 20.5968 22.9574 20.9784H9.02503L9.65509 20.0466H22.2297ZM22.8331 17.9346H8.56357C7.57855 19.2657 6.15869 21.5286 6.15869 21.5286C6.16334 21.9382 6.32873 22.3296 6.61921 22.6184C6.9097 22.9072 7.30203 23.0704 7.71166 23.0727H24.2796C24.6938 23.0727 25.0911 22.9081 25.384 22.6152C25.6769 22.3223 25.8414 21.925 25.8414 21.5108C25.8414 21.5108 23.6939 17.9168 22.8331 17.9168V17.9346Z"
          fill={color}
        />
      </Svg>
    </View>
  );
}
